import React from 'react';
import { Flex } from '../../Flex';
import { Typography } from '../../Typography';
import { StyledSystemProps } from '../../../types';
import { Icon } from '../../../wag-react/components/icon';
type Props = StyledSystemProps & {
  src: string;
  value: string;
  textProps?: StyledSystemProps;
  alt?: string;
};
export const Label = ({
  src,
  value,
  textProps,
  alt,
  ...rest
}: Props) => <Flex alignItems="center" flexDirection={['row', 'column']} {...rest} data-sentry-element="Flex" data-sentry-component="Label" data-sentry-source-file="Label.tsx">
    <Icon src={src} width={['20px', '24px']} height={['20px', '24px']} alt={alt} mr="4px" data-sentry-element="Icon" data-sentry-source-file="Label.tsx" />
    <Typography m={0} fontSize={['14px', '16px']} lineHeight="1.5" {...textProps} data-sentry-element="Typography" data-sentry-source-file="Label.tsx">
      {value}
    </Typography>
  </Flex>;